import { render, staticRenderFns } from "./DetailShoppingCart.vue?vue&type=template&id=64389764&"
import script from "./DetailShoppingCart.vue?vue&type=script&lang=js&"
export * from "./DetailShoppingCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports